import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { TranslateService } from '@ngx-translate/core';
import { DivisionSalesNetworkService } from './../../../../services/division-sales-network/divison-sales-network.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { StoreCommonService } from './../../../../services/store/store-common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/components/common/api';

@Component({
  selector: 'app-user-stores-and-sales-networks',
  templateUrl: './user-stores-and-sales-networks.component.html',
  styleUrls: ['./user-stores-and-sales-networks.component.css']
})
export class UserStoresAndSalesNetworksComponent implements OnInit {

  userId: string;
  userStoreAndSalesNetworks: any[];
  showDialog = false;
  dialogTitle: string;
  addDialogTitle: string;
  editDialogTitle: string;
  form: FormGroup;
  invalidSubmit: boolean;
  fields: any;
  stores: SelectItem[] = [{ value: null, label: '' }];
  salesNetworks: SelectItem[] = [{ value: null, label: '' }];
  storeFieldDisabled = false;
  salesNetworkFieldDisabled = false;
  editMode = false;
  listStates: SelectItem[] = [];
  customFilter = KontableComponent.CustomFilter;
  statusFilter = '';
  formError = false;
  selectedStore: SelectItem = {label: null, value: null};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storeSvc: StoreCommonService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private divisionSalesNetworkSvc: DivisionSalesNetworkService
  ) { }

  ngOnInit() {

    // Ricavo id utente selezionato in Company Admin dalla Url
    this.userId = this.route.snapshot.paramMap.get('id');

    this.translate.get([
      'common.add',
      'common.edit',
      'common.all',
      'common.storeOrSalesNetwork',
      'common.status_notDeleted',
      'common.status_onlyDeleted'
    ]).subscribe(res => {

      this.addDialogTitle = `${res['common.add']} ${res['common.storeOrSalesNetwork']}`;
      this.editDialogTitle = `${res['common.edit']} ${res['common.storeOrSalesNetwork']}`;
      this.listStates.push({label: res['common.all'], value: ''});
      this.listStates.push({label: res['common.status_notDeleted'], value: '0'});
      this.listStates.push({label: res['common.status_onlyDeleted'], value: '1'});

      this.getTableData();

    });

    // Richiamo il Dto relativo al form
    this.storeSvc.getUserStoreDivisionFields().subscribe(res => this.fields = res);

    // Popolo il dropdown Negozi
    this.storeSvc.getList().subscribe(stores => stores.forEach(store => this.stores.push({value: store.id, label: store.name})));

    // Popolo il dropdown Reti di Vendita
    this.divisionSalesNetworkSvc.getSalesNetworkDivisionList().subscribe(salesNetworks => salesNetworks.forEach(sn => this.salesNetworks.push({value: sn.id, label: `${sn.sales_network_name} - ${sn.division_name}`})));

  }

  /**
   * Popola la table con i Negozi e le Reti di Vendita
   */
  getTableData() {
    this.storeSvc.getUserStoresAndSalesNetworks(this.userId).subscribe(res => this.userStoreAndSalesNetworks = res);
  }

  /**
   * Riporta al componente di Company Admin
   */
  goBack() {
    this.router.navigateByUrl('/company-admin');
  }

  /**
   * Apre modale form
   * @param event
   */
  openDialog(event) {
    if (event) {
      this.form = this.fb.group({
        'id': event.id,
        'store_id': new FormControl(event.store_id),
        'division_sales_network_id': new FormControl(event.division_sales_network_id)
      });
      if (event.store_id) {
        this.storeSvc.get(event.store_id).subscribe(
          res =>{
                if(res.name === undefined || res.name === null)
                  this.selectedStore =({ label: `${res.code} - --`, value: `${res.id}` });
                else
                  this.selectedStore =({ label: `${res.code} - ${res.name}, ${res.address_1}, ${res.city}`, value: `${res.id}` });  
              }
        )
        this.salesNetworkFieldDisabled = true;
      } else if (event.division_sales_network_id) {
        this.storeFieldDisabled = true;
      }
      this.editMode = true;
    } else {
      this.form = this.fb.group({
        'store_id': new FormControl(null),
        'division_sales_network_id': new FormControl(null)
      })
    }
    this.dialogTitle = event ? this.editDialogTitle : this.addDialogTitle;
    this.showDialog = true;
  }

  /**
   * Chiude modale form
   */
  closeDialog() {
    this.storeFieldDisabled = false;
    this.salesNetworkFieldDisabled = false;
    this.form.controls.store_id.setValue({value: null, label: ''});
    this.form.controls.division_sales_network_id.setValue({value: null, label: ''});
    this.editMode = false;
    this.showDialog = false;
    this.formError = false;
  }

  deleteElement(event) {
    this.storeSvc.deleteUserStoreDivisions(event.id).subscribe(() => this.getTableData());
  }

  saveOrUpdate() {
    if (!this.form.controls.store_id.value && !this.form.controls.division_sales_network_id.value) {
      this.formError = true;
      return;
    }
    const data = {user_id: +this.userId, ...this.form.value};
    data.store_id = +this.selectedStore.value === 0 ? null : this.selectedStore.value;
    if (this.editMode) {
      this.storeSvc.putUserStoreDivision(data.id, data).subscribe(() => {
        this.getTableData();
        this.closeDialog();
      });
    } else {
      this.storeSvc.postUserStoreDivision(data).subscribe(() => {
        this.getTableData();
        this.closeDialog();
      });
    }
  }

  /**
   * Disabilita il dropdown delle Reti di Vendita quando un negozio viene selezionato,
   * lo riabilita quando, nel dropdown Negozi, viene selezionato il campo vuoto
   * @param event
   */
  storeSelected(event) {
    event.value ? this.salesNetworkFieldDisabled = true : this.salesNetworkFieldDisabled = false;
  }

  /**
   * Disabilita il dropdown dei Negozi quando una rete di vendita viene selezionata,
   * lo riabilita quando, nel dropdown Reti di Vendita, viene selezionato il campo vuoto
   * @param event
   */
  salesNetworkSelected(event) {
    event.value ? this.storeFieldDisabled = true : this.storeFieldDisabled = false;
  }

  getFilteredStores(event) {
    this.stores = [{
      label: '',
      value: -1
    }];
    if (event.query) {
      this.storeSvc.getStoreByNameNew(event.query).subscribe(stores => stores.map( res=> {
        if(res.name === undefined || res.name === null)
          this.stores.push ({ label: `${res.code} - --`, value: `${res.id}` });
        else
          this.stores.push({ label: `${res.code} - ${res.name}, ${res.address_1}, ${res.city}`, value: `${res.id}` });      
        }))
    } else {
      
      this.storeSvc.getList().subscribe(stores => stores.map(store => {
        if(store.name === undefined || store.name === null)
            this.stores.push({ label: `${store.code} - --`, value: `${store.id}` });
        else
          this.stores.push({ label: `${store.code} - ${store.name}, ${store.address_1}, ${store.city}`, value: `${store.id}` });      
        }))
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/user-stores-and-sales-networks/user-stores-and-sales-networks.component.ts